import { BasicProps } from "./ComponentsInterface";
import { LBtn } from "./LBtn";

export const LNotification = ({ children }: NotificationProps): JSX.Element => {
    return (
        <div className="notification is-danger">
            <LBtn classes="delete">X</LBtn>
            {children}
        </div>
    );
};

interface NotificationProps extends BasicProps {}
